function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function PeaceOfMind(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0zm0 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8.415 14.68c.016.01 1.824 1.073 3.741 1.073s3.725-1.063 3.743-1.074a1 1 0 011.03 1.714c-.093.055-2.289 1.36-4.773 1.36-2.484 0-4.68-1.305-4.772-1.36a1 1 0 011.031-1.713zm-1.36-6.226c.13.097 1.233.86 2.549-.035a1 1 0 011.122 1.656c-.832.565-1.664.767-2.411.767-1.098 0-2.014-.437-2.486-.808a1 1 0 011.226-1.58zm7.39 0c.13.096 1.231.86 2.548-.035a1 1 0 111.122 1.656c-.832.565-1.664.767-2.41.767-1.098 0-2.014-.437-2.487-.808a1 1 0 011.227-1.58z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoPeaceOfMind = /*#__PURE__*/React.memo(PeaceOfMind);
export default MemoPeaceOfMind;